import styled from 'styled-components'

export const Content = styled.div`
  float: left;
  width: 100%;
  padding: 0 40px 30px 40px;
  background: #000000;
  display: flex;
  align-items: center;
  justify-content: flex-end;


  @media only screen and (max-width: 900px) {
    padding: 0 15px 30px 15px;
    justify-content: center;
  }

`

export const Texto = styled.span`
  color: #A9ABBD;
  font-weight: bold;
  font-size: 14px;
  display: inline-block;

  @media only screen and (max-width: 900px) {
    font-size: 12px;
    text-align: center;
  }
`

export const ContainerBotoes = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 15px;
  background-color: #000;
  border: solid 2px #fff;
  border-radius: 50px;
  padding: 3px;

  .active {
    background: #fff;
  }

  @media only screen and (max-width: 900px) {
    margin: 0 5px;
  }
`

export const Botao = styled.button`
  width: 15px;
  height: 15px;
  transition: all .2s linear 0s;
  border-radius: 50px;
  border: 0;
  background: none;

  @media only screen and (max-width: 900px) {
    padding: 8px 8px;
  }
`
